module.exports = __webpack_public_path__ + "img/1.871b4955.jpg";